import bodyLock from "../utils/body-lock";

let runComponent = false;

class HeaderComponent extends HTMLElement {
  constructor() {
    super();

    const init = () => {
      handleAnnouncementBarScroll();
      handleAnnouncementBarEventListeners();
      handleSafariTheme();
      handleMobileToggle();
      handleNavigationButtonClick();
      handleMegaMenu();
    };
    const dropAHintForm = document.querySelector(".drop-a-hint-form");

    /**
     * Hide announcement bar.
     *
     * @param headerElement
     * @type {HTMLElement}
     */
    const hideAnnouncementBar = (headerElement) => {
      const announcementBarElement =
        document.querySelector(".announcement-bar");

      if (headerElement && announcementBarElement) {
        announcementBarElement.classList.add("header--has-scrolled");
        headerElement.classList.add("header--has-scrolled");
        headerElement.style.transform = `translateY(0px)`;
        dropAHintForm?.classList.add("drop-a-hint-form--has-scrolled");
      }
    };

    /**
     * Set hide announcement bar state in a session storage.
     *
     * @param state
     * @type {Boolean}
     */
    const setHideAnnouncementBarSession = (state) => {
      sessionStorage.setItem("showAnnouncementBar", state);
    };

    /**
     * Get state from session of the announcement bar.
     */
    const getStateOfAnnouncementBarSession = () => {
      return sessionStorage.getItem("showAnnouncementBar");
    };

    /**
     * Show announcement bar.
     *
     * @param headerElement
     */
    const showAnnouncementBar = (headerElement) => {
      const announcementBarElement =
        document.querySelector(".announcement-bar");
      const announcementBarHeight = announcementBarElement.offsetHeight;
      const sessionState = getStateOfAnnouncementBarSession();

      if (headerElement && announcementBarElement) {
        if (sessionState === "false") {
          announcementBarElement.classList.add("js-disabled");
        } else {
          headerElement.style.transform = `translateY(${announcementBarHeight}px)`;
        }

        announcementBarElement.classList.remove("header--has-scrolled");
        headerElement.classList.remove("header--has-scrolled");
        dropAHintForm?.classList.remove("drop-a-hint-form--has-scrolled");
      }
    };

    /**
     * Handle announcement bar scroll
     */
    const handleAnnouncementBarScroll = () => {
      const headerElement = document.querySelector(".header");
      const sessionState = getStateOfAnnouncementBarSession();

      const announcementBarElement =
        document.querySelector(".announcement-bar");

      if (sessionState === "false") {
        announcementBarElement.classList.add("js-disabled");
      } else {
        showAnnouncementBar(headerElement);
      }

      if (headerElement) {
        const announcementBarElement =
          document.querySelector(".announcement-bar");
        const announcementBarHeight = announcementBarElement.offsetHeight;
        const offset = announcementBarHeight * 3;
        // Safari theme color
        const themeColorElement = document.querySelector(
          'meta[name="theme-color"]'
        );
        const themeColor = window.topBarColor;

        window.addEventListener("scroll", function () {
          let scrollPosition = window.scrollY;

          if (scrollPosition > offset) {
            hideAnnouncementBar(headerElement);
            // Safari Theme color
            if (themeColor) {
              themeColorElement.setAttribute("content", "#F8F3ED");
            }
          } else {
            showAnnouncementBar(headerElement);
            // Safari Theme color
            if (themeColor) {
              themeColorElement.setAttribute("content", themeColor);
            }
          }
        });
      }
    };

    /**
     * Handle announcement bar events.
     */
    const handleAnnouncementBarEventListeners = () => {
      const headerElement = document.querySelector(".header");
      const announcementBarCloseButtonElement = document.querySelector(
        "#js-close-announcement-bar"
      );

      if (announcementBarCloseButtonElement && headerElement) {
        announcementBarCloseButtonElement.addEventListener("click", () => {
          setHideAnnouncementBarSession(false);
          hideAnnouncementBar(headerElement);
        });
      }
    };

    /**
     * Handle safari theme color for scroll effect
     *
     * @returns
     */
    const handleSafariTheme = () => {
      const themeColorElement = document.querySelector(
        'meta[name="theme-color"]'
      );
      const themeColor = window.topBarColor;

      if (themeColor) {
        themeColorElement.setAttribute("content", themeColor);
      }
    };

    /**
     * Mobile menu toggle switcher
     *
     * @returns
     */
    const handleMobileToggle = () => {
      const toggle = document.querySelector(".js-trigger-mobile-menu");
      const mobileNav = document.querySelector(".mobile-menu__container");
      const headerElement = document.querySelector(".header");

      if (!toggle) return false;

      const toggleCloseText = toggle.getAttribute("data-close-text");
      const toggleOpenText = toggle.innerHTML;

      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        toggle.classList.toggle("js-open");
        headerElement.classList.toggle("js-active");
        mobileNav.classList.toggle("js-navigation-open");

        // Now check the status of the mobileMenu for body-scroll-lock
        if (mobileNav.classList.contains("js-navigation-open")) {
          // add body scroll lock.
          bodyLock.lock();

          toggle.innerHTML = toggleCloseText;
        } else {
          // remove body scroll lock.
          bodyLock.unlock();
          toggle.innerHTML = toggleOpenText;
        }
      });
    };

    /**
     * Close mega menu.
     *
     * @param megaMenuElement
     */
    const closeMegaMenu = (megaMenuElement) => {
      if (megaMenuElement) {
        megaMenuElement.classList.remove("js-mega-menu-open");
        megaMenuElement.style.transform = "translateX(100%)";
      }
    };

    /**
     * Open mega menu.
     *
     * @param megaMenuElement
     */
    const openMegaMenu = (megaMenuElement) => {
      if (megaMenuElement) {
        megaMenuElement.classList.add("js-mega-menu-open");
        megaMenuElement.style.transform = "translateX(0)";
      }
    };

    /**
     * Handle open mobile mega menu.
     *
     * @param megaMenuId
     */
    const handleOpenMobileMegaMenu = (megaMenuId) => {
      const megaMenuElement = document.getElementById(megaMenuId);

      if (megaMenuElement.classList.contains("js-mega-menu-open")) {
        closeMegaMenu(megaMenuElement);
      } else {
        openMegaMenu(megaMenuElement);
      }
    };

    /**
     * Handle Navigation button click.
     */
    const handleNavigationButtonClick = () => {
      const allNavigationMenuItem = document.querySelectorAll(
        ".js-trigger-mega-menu"
      );

      allNavigationMenuItem.forEach((navigationMenuItem) => {
        const megaMenuId = navigationMenuItem.dataset.menuId;

        navigationMenuItem.addEventListener("click", () => {
          handleOpenMobileMegaMenu(megaMenuId);
        });
      });
    };

    /**
     * Enable the mega menu switching
     *
     * @returns
     */
    const handleMegaMenu = () => {
      const menuButtons = document.querySelectorAll(
        ".header .nav__button:not(.nav__button--dropdown)"
      );
      const megaMenuButtons = document.querySelectorAll(
        ".header .nav__button.nav__button--dropdown"
      );

      if (megaMenuButtons.length === 0) return false;

      // Menu only for iPad and above
      const breakpointTablet = "1024px";
      if (!matchMedia(`screen and (min-width: ${breakpointTablet})`).matches)
        return false;

      /* Add one or more listeners to an element
       ** @param {DOMElement} element - DOM element to add listeners to
       ** @param {string} eventNames - space separated list of event names, e.g. 'click change'
       ** @param {Function} listener - function to attach for each event as a listener
       */
      function addListenerMulti(el, s, fn) {
        s.split(" ").forEach((e) => el.addEventListener(e, fn, false));
      }

      // Specific handlers
      const closeAllMegaMenu = () => {
        megaMenuButtons.forEach((button) =>
          button.classList.remove("js-active")
        );
      };

      window.addEventListener("scroll", function () {
        closeAllMegaMenu();
      });

      // Close events
      menuButtons.forEach((button) =>
        button.addEventListener("mouseenter", () => closeAllMegaMenu())
      );

      // Close megamenu's when clicked outside of it. Especially for iPad landscape.
      document.addEventListener("click", (e) => {
        const header = document.querySelector(".header");
        const megaMenu = document.querySelector(".mega-menu-container");
        let target = e.target;
        do {
          if (target == megaMenu || target == header) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          target = target.parentNode;
        } while (target);
        // This is a click outside.
        closeAllMegaMenu();
      });

      const hideAllOpenMenus = () => {
        megaMenuButtons.forEach((button) => {
          button.classList.remove("js-active");
        });
      };

      megaMenuButtons.forEach((button) => {
        addListenerMulti(button, "click mouseenter", (event) => {
          hideAllOpenMenus();
          event.preventDefault();
          if (button) button.classList.add("js-active");
        });
      });
    };


    if (!runComponent) {
      init();
      runComponent = true;
    }
  }
}

customElements.define("header-component", HeaderComponent);
